import {
  CustomerRefundShipmentCourierBadge,
  CustomerRefundShipmentCourierServiceTypeBadge,
  CustomerRefundShipmentStatusBadge
} from 'domains/customer-refund-shipment/atoms'
import PropTypes from 'prop-types'
import React from 'react'
import { Card, CardHeader, Table } from 'reactstrap'
import PriceUtil from 'utils/price-util'
import TimeUtil from 'utils/time-util'


const propTypes = {
  refundShipment: PropTypes.shape({
    number               : PropTypes.string,
    recipient_name       : PropTypes.string,
    recipient_phone      : PropTypes.string,
    dest_street_address  : PropTypes.string,
    dest_sub_district    : PropTypes.string,
    dest_district        : PropTypes.string,
    dest_city            : PropTypes.string,
    dest_province        : PropTypes.string,
    dest_postal_code     : PropTypes.string,
    status               : PropTypes.string,
    courier              : PropTypes.string,
    courier_service_type : PropTypes.string,
    weight               : PropTypes.string,
    cost                 : PropTypes.string,
    tracking_no          : PropTypes.string,
    shipped_at           : PropTypes.string
  })
}

const CustomerRefundShipmentCard = ({
  refundShipment
}) => (
  <Card>
    <CardHeader>
      <span className='small text-uppercase text-light font-weight-bolder'>
        { 'Customer Refund Shipment' }
      </span>
      <h2 className='pt-2'>
        <span className='mr-3'>
          { `Refund Shipment #${refundShipment.number}` }
        </span>
        <small>
          <CustomerRefundShipmentStatusBadge status={ refundShipment.status } />
        </small>
      </h2>
    </CardHeader>

    <Table bordered className='mb-0' hover>
      <tbody>
        <tr>
          <th scope='row'>Recepient Name</th>
          <td className='text-wrap'>{ refundShipment.recipient_name }</td>
        </tr>
        <tr>
          <th scope='row'>Recepient Phone</th>
          <td>{ refundShipment.recipient_phone }</td>
        </tr>
        <tr>
          <th scope='row'>Destination Address</th>
          <td className='text-wrap'>{ [
            refundShipment.dest_street_address,
            refundShipment.dest_sub_district,
            refundShipment.dest_district,
            refundShipment.dest_city,
            refundShipment.dest_province,
            refundShipment.dest_postal_code
          ].join(', ') }
          </td>
        </tr>
        <tr>
          <th scope='row'>Courier</th>
          <td>{ <CustomerRefundShipmentCourierBadge courier={ refundShipment.courier } /> }</td>
        </tr>
        <tr>
          <th scope='row'>Courier Service Type</th>
          <td>{ <CustomerRefundShipmentCourierServiceTypeBadge courier_service_type={ refundShipment.courier_service_type } /> }</td>
        </tr>
        <tr>
          <th scope='row'>Weight (Kg)</th>
          <td>{ refundShipment.weight }</td>
        </tr>
        <tr>
          <th scope='row'>Cost</th>
          <td>{ PriceUtil.format(refundShipment.cost) }</td>
        </tr>
        <tr>
          <th scope='row'>Tracking No.</th>
          <td>{ refundShipment.tracking_no }</td>
        </tr>
        <tr>
          <th scope='row'>Shipped At</th>
          <td>{ TimeUtil.format(refundShipment.shipped_at) }</td>
        </tr>

      </tbody>
    </Table>
  </Card>
)

CustomerRefundShipmentCard.propTypes = propTypes

export default CustomerRefundShipmentCard
